import { Eye, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const viewing = user?._viewing_as;
  if (!viewing) return null;

  const exit = async () => {
    try {
      const { data } = await api.post("/admin/impersonate/end");
      localStorage.setItem("ld_token", data.token);
      await refresh();
      toast.success("Exited impersonation");
      window.location.href = "/admin";
    } catch { toast.error("Failed to exit"); }
  };

  return (
    <div data-testid="impersonation-banner" className="flex items-center gap-3 px-6 py-2.5 border-b text-white" style={{ background: "linear-gradient(90deg, #FF4D00, #F59E0B)", borderColor: "#F59E0B" }}>
      <Eye className="w-4 h-4 shrink-0" />
      <span className="text-sm">
        Viewing workspace as <strong>{viewing.name || viewing.email}</strong> ({viewing.email})
        {user?._impersonator && <span className="opacity-80"> · signed in as {user._impersonator.email}</span>}
      </span>
      <Button data-testid="exit-impersonation" size="sm" variant="secondary" className="ml-auto gap-1 h-7 bg-white/95 text-slate-900 hover:bg-white" onClick={exit}>
        <LogOut className="w-3.5 h-3.5" /> Exit impersonation
      </Button>
    </div>
  );
}
